/* eslint-disable jsx-a11y/img-redundant-alt */
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Zoom, Controller } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/zoom";
import "./ImageSwiper.css";

const ImageSwiper = ({ images, product, toggleSave }) => {
  const [loadedImages, setLoadedImages] = useState(
    Array(images.length).fill(false)
  );
  const [activeIndex, setActiveIndex] = useState(0);
  const [isFullScreen, setIsFullScreen] = useState(false);

  const handleImageLoad = (index, link) => {
    setLoadedImages((prev) => {
      const newState = [...prev];
      newState[index] = link;
      return newState;
    });
  };

  const handleFullScreenToggle = () => {
    setIsFullScreen(!isFullScreen);
    if (!isFullScreen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const swiperParams = {
    modules: [Pagination, Zoom, Navigation],
    spaceBetween: 2,
    speed: 700,
    pagination: {
      clickable: true,
      el: ".external-pagination",
      bulletClass: "custom-bullet",
      bulletActiveClass: "custom-bullet-active",
    },
    zoom: false,
    loop: true,
    className: "image-swiper",
    onSlideChange: (swiper) => {
        setActiveIndex(swiper.realIndex);
      }
  };

  return (
    <>
      <div className="image-swiper-container">
        <Swiper
          key={isFullScreen ? "fullscreen" : "main"} // Уникальный ключ
          {...swiperParams}
          initialSlide={activeIndex}
        >
          {images.map((image, index) => (
            <SwiperSlide key={image} onClick={handleFullScreenToggle}>
              <div className="swiper-zoom-container">
                <img
                  src={image}
                  alt={`Image ${index + 1}`}
                  fetchpriority="high"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: !loadedImages[index] ? "blur(3px)" : "none",
                    transition: "filter 0.3s ease-in-out",
                  }}
                  loading="eager"
                  onLoad={() => handleImageLoad(index, image)}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div
          className="external-pagination"
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "5px",
          }}
        />
        <button
          className="product-list-favorite-icon"
          onClick={(e) => {
            e.stopPropagation(); // Предотвращаем всплытие
            toggleSave(product);
          }}
          style={{ top: "15px", right: "10px" }}
        >
          <span
            className="material-symbols-sharp"
            style={{
              fontVariationSettings: `'FILL' ${
                product?.favourite?.id ? 1 : 0
              }, 'wght' 400, 'GRAD' 0, 'opsz' 24`,
              transition: "font-variation-settings 0.3s ease-in-out",
              cursor: "pointer",
            }}
          >
            bookmark
          </span>
        </button>
      </div>
      {isFullScreen && (
        <div 
          className="fullscreen-swiper-modal"
        >
          <button
            className="fullscreen-swiper-close-btn"
            onClick={handleFullScreenToggle}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="product-image-icon-close"
              viewBox="0 0 14 14"
              width="20"
              height="20"
              aria-hidden="true"
              focusable="false"
              role="presentation"
              fill="none"
            >
              <path
                d="M.693 1.4l11.749 11.749.707-.707L1.4.693z"
                fill="currentColor"
              ></path>
              <path
                d="M12.442.693L.693 12.442l.707.707L13.149 1.4z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
          <Swiper
            key="fullscreen"
            {...swiperParams}
            initialSlide={activeIndex}
            zoom={true}
          >
            {images.map((image, index) => (
              <SwiperSlide key={image}>
                <div className="swiper-zoom-container">
                  <img
                    src={image}
                    alt={`Full screen ${index + 1}`}
                    className="fullscreen-swiper-image"
                    loading="eager"
                    style={{
                      filter: !loadedImages[index] ? "blur(3px)" : "none",
                      transition: "all 0.3s ease-in-out",
                    }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default ImageSwiper;